import { render } from "./ProductPhotoCarousel.vue?vue&type=template&id=68642e32&scoped=true"
import script from "./ProductPhotoCarousel.vue?vue&type=script&lang=js"
export * from "./ProductPhotoCarousel.vue?vue&type=script&lang=js"

import "./ProductPhotoCarousel.vue?vue&type=style&index=0&id=68642e32&scoped=true&lang=css"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.33_vue@3.5.33_webpack@5.89.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68642e32"]])

export default __exports__